import { render, staticRenderFns } from "./SignupLinksSection.vue?vue&type=template&id=354c3941&scoped=true"
import script from "./SignupLinksSection.vue?vue&type=script&lang=js"
export * from "./SignupLinksSection.vue?vue&type=script&lang=js"
import style0 from "./SignupLinksSection.vue?vue&type=style&index=0&id=354c3941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c3941",
  null
  
)

export default component.exports